import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  AuthConfigToken,
  THDSAngularAuthService,
  IAuthModuleConfig,
} from './thds-angular-auth.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
// @dynamic
export class THDSAngularAuthModule {
  static forRoot(
    config: IAuthModuleConfig,
  ): ModuleWithProviders<THDSAngularAuthModule> {
    return {
      ngModule: THDSAngularAuthModule,
      providers: [
        THDSAngularAuthService,
        {
          provide: AuthConfigToken,
          useValue: config,
        },
      ],
    };
  }
}
